// Shared formatting helpers for the Activity analytics dashboard.
// Mirrors the fr-FR / "DH" conventions already used across the Activite module.

export const formatCurrency = (value) => {
    const numberValue = Number(value || 0);
    return (
        numberValue.toLocaleString("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) + " DH"
    );
};

export const formatNumber = (value) => {
    const numberValue = Number(value || 0);
    return numberValue.toLocaleString("fr-FR");
};

export const formatPercent = (value) => {
    const numberValue = Number(value || 0);
    return (
        numberValue.toLocaleString("fr-FR", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) + " %"
    );
};

export const formatText = (value) => {
    if (value === null || value === undefined || value === "") return "—";
    return String(value);
};

// Dispatch a raw value through the requested format.
export const formatByType = (value, format) => {
    switch (format) {
        case "currency":
            return formatCurrency(value);
        case "number":
            return formatNumber(value);
        case "percent":
            return formatPercent(value);
        case "text":
        default:
            return formatText(value);
    }
};
